<template>
    <v-col cols="12" sm="6" md="6" lg="3" class="mx-auto mt-5">
        <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
            <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-alert
                    dense
                    outlined
                    type="error" v-for="error in errors" :key="error">
                {{ error }}
                </v-alert>
                <v-form>
                    <v-text-field
                        v-model="email"
                        type="email"
                        label="Email"
                        :error-messages="emailErrors"
                        required
                        prepend-icon="mdi-at"
                        @input="$v.email.$touch()"
                        @blur="$v.email.$touch()">
                    </v-text-field>
                    <v-text-field
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        label="Password"
                        required
                        prepend-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                        :error-messages="passwordErrors"
                        @input="$v.password.$touch()"
                        @blur="$v.password.$touch()">
                    </v-text-field>
                </v-form>
                <div>
                  This site is protected by reCAPTCHA and the Google
                  <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                  <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="success" :to="{ name: 'register'}">Register</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="info" @click="submit">Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-col>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    data() {
        return {
            showPassword: false,
            email: '',
            password: '',
            errors: [],
        }
    },
    computed: {
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.email && errors.push('Must be valid e-mail');
            !this.$v.email.required && errors.push('E-mail is required');
            return errors;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.required && errors.push('Password is required');
            return errors
        }
    },
    validations: {
        email: { required, email },
        password: { required, email },
    },
    methods: {
        async submit() {
            await this.$recaptchaLoaded()

            // Execute reCAPTCHA with action "login".
            const token = await this.$recaptcha('login')

            this.$store.dispatch('login', {
                email: this.email,
                password: this.password,
                '_recaptcha': token,
            }).catch(result => {
                if (result.response.status === 401) {
                    this.errors = [result.response.data.message];
                } else {
                    this.errors = result.response.data.data.messages;
                }
            });
        }
    },
}
</script>

<style>

</style>